import React, { Component } from 'react';
import { Card, CardBody } from "reactstrap";
import ReportHeader from './ReportHeader';
import ReportFooter from './ReportFooter';
import ReportHeader_Swiss from './ReportHeader_Swiss';
import ReportFooter_Swiss from './ReportFooter_Swiss';
import PropTypes from 'prop-types';

export class PhotoGalleryImages extends Component {
  lang = (word) => {
    const { lang, words } = this.props;
    return words[word] ? words[word][lang] : word;
  };

  render() {
    const { extraImagesArr, tempExtraImagesArr, isExtraImages } = this.props;
    const client = localStorage.getItem("client");
    const unwantedNames = ["pre-Damage-1", "pre-Damage-2", "pre-Damage-3", "pre-Damage-4"];
    
    const filteredExtraImagesArr = extraImagesArr.map((data) =>
      data.map((innerData) => innerData.filter((name) => !unwantedNames.includes(name)))
    );

    // const hasValidContent = filteredExtraImagesArr.some((data) =>
    //   data.some((innerData) => innerData.length > 0)
    // );

    // if (!hasValidContent) {
    //   return null;
    // }

    return (
      isExtraImages && filteredExtraImagesArr.map((data, i) => (
        <div className="row row-zero page-break-row report-full-wrapper" key={i} data-content-name={this.lang("Page")}>
          <div className="col-sm-12 full-height-col col-zero">
            <Card>
              <CardBody className="col-zero">
                <div className="newFormatReport_wrapper">
                  <ReportHeader_Swiss />
                  <div className="container">
                    <div className="row title-row-main">
                      <div className="col-sm-12 col-zero">
                        <h3 className="report-title">
                          {this.lang("Extra")} <span>{this.lang("Images")}</span>
                        </h3>
                      </div>
                    </div>
                    <div className="all_photo_images">
                      {data.map((innerData, j) => (
                        <div className="row left-side-row" key={j}>
                          {innerData.map((name, k) => {
                            if (!name) return null;
                            return (
                              <div className="col-lg-6 col-md-6 col-sm-12 col-zero" key={k}>
                                <div className="row row-zero photo_gallery_border_row">
                                  <div className="col-sm-12 photo_gallery_border_col">
                                    <div className="photo_gallery_img">
                                      <img
                                        src={`${tempExtraImagesArr[name].name}?${Date.now()}`}
                                        alt={name}
                                      />
                                      <p className="photo_gallery_text">{this.lang(name)}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </CardBody>
              <ReportFooter_Swiss reportType="newReportFull" />
            </Card>
          </div>
        </div>
      ))
    );
  }
}


export default PhotoGalleryImages;
